var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotifications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 180,
    viewBox: "0 0 209 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.629883 0H208.65V179.72H0.629883V0Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.31 18.6794L70.4399 18.3094C32.0699 18.1294 0.809931 49.0994 0.629931 87.4694C0.449931 125.849 31.4199 157.099 69.7899 157.279L72.0199 157.359C82.7399 157.409 92.6999 162.939 98.3999 172.019L103.23 179.709L108.14 172.059C113.93 163.029 123.93 157.599 134.66 157.649C173.04 157.829 204.29 126.859 204.47 88.4894C204.66 50.1194 173.69 18.8594 135.31 18.6794Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M197.83 58.4897C186.75 35.0597 162.95 18.8097 135.31 18.6797H135.1C127.65 25.6797 122.99 35.6097 122.99 46.6297C122.99 67.8097 140.16 84.9897 161.35 84.9897C178.4 84.9897 192.84 73.8697 197.83 58.4897Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.11 69.3203H47.2798V72.3203H160.11V69.3203Z",
    fill: "#B3BAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.11 82.4102H47.2798V85.4102H160.11V82.4102Z",
    fill: "#B3BAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.11 95.5098H47.2798V98.5098H160.11V95.5098Z",
    fill: "#B3BAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.11 108.6H47.2798V111.6H160.11V108.6Z",
    fill: "#B3BAC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.29 76.72C191.476 76.72 208.65 59.5456 208.65 38.36C208.65 17.1744 191.476 0 170.29 0C149.104 0 131.93 17.1744 131.93 38.36C131.93 59.5456 149.104 76.72 170.29 76.72Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.59 41.9295L190.62 34.9295C190.62 33.8995 189.79 33.0595 188.76 33.0495L175.68 32.9995L175.73 19.9295C175.73 18.8995 174.9 18.0595 173.87 18.0495L166.87 18.0195C165.84 18.0195 165 18.8495 164.99 19.8795L164.94 32.9495L151.87 32.8995C150.84 32.8995 150 33.7295 149.99 34.7595L149.96 41.7595C149.96 42.7895 150.79 43.6295 151.82 43.6395L164.89 43.6895L164.84 56.7595C164.84 57.7895 165.67 58.6295 166.7 58.6395L173.7 58.6695C174.73 58.6695 175.57 57.8395 175.58 56.8095L175.63 43.7395L188.7 43.7895C189.75 43.7995 190.59 42.9695 190.59 41.9295Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 37.2927,
    y1: 153.245,
    x2: 167.814,
    y2: 22.7233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0977,
    stopColor: "#C1C7D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9947,
    stopColor: "#EBECF0",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 134.236,
    y1: 73.7576,
    x2: 188.48,
    y2: 19.5141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C7D0",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1413,
    stopColor: "#C1C7D0",
    stopOpacity: 0.2272
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C7D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 143.167,
    y1: 65.4777,
    x2: 197.411,
    y2: 11.2342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.629883 0H208.65V179.72H0.629883V0Z",
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.26e0b2dd522a2591d9610a46be64cbf2.svg";
export { ForwardRef as ReactComponent };